import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexModule } from '@ngbracket/ngx-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { FormErrorModule, TextEditorModule, UiModule } from '@eg/ui';
import { MessageMailTemplateComponent } from './message-mail-template.component';

@NgModule({
  declarations: [MessageMailTemplateComponent],
  imports: [CommonModule, FormErrorModule, UiModule, TextEditorModule, FlexModule, ReactiveFormsModule],
  exports: [MessageMailTemplateComponent],
})
export class MessageMailTemplateModule {}
